
// // AuthContext.jsx
// import { createContext, useContext, useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import BASE_URL from "../config/config";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const navigate = useNavigate();
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Check for token in localStorage when app loads
//     const token = localStorage.getItem("token");
//     const userData = localStorage.getItem("user");
    
//     if (token) {
//       setIsAuthenticated(true);
//       if (userData) {
//         setUser(JSON.parse(userData));
//       }
//     }
//     setLoading(false);
//   }, []);

//   const login = async (email, password) => {
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/admin/auth/authenticate`,
//         { email, password },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       const data = response.data;
//       const token = data.token || data.data?.token;
//       const userInfo = data.user || data.data?.user || { email };

//       if (token) {
//         // Store token and user info in localStorage
//         localStorage.setItem("token", token);
//         localStorage.setItem("user", JSON.stringify(userInfo));
        
//         // Update state
//         setUser(userInfo);
//         setIsAuthenticated(true);
        
//         // Navigate to dashboard
//         navigate("/admin/dashboard");
//         return { success: true };
//       } else {
//         alert("Login failed: Token missing in response");
//         return { success: false };
//       }
//     } catch (error) {
//       console.error("Login error:", error);
//       const errorMessage = error.response?.data?.message || "Invalid email or password";
//       alert(errorMessage);
//       return { success: false };
//     }
//   };

//   const logout = () => {
//     // Clear localStorage
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
    
//     // Update state
//     setIsAuthenticated(false);
//     setUser(null);
    
//     // Navigate to login
//     navigate("/admin/login");
//   };

//   return (
//     <AuthContext.Provider value={{ isAuthenticated, user, login, logout, loading }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error("useAuth must be used within an AuthProvider");
//   }
//   return context;
// };


// AuthContext.jsx
import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../config/config";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Logout Function
  const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("tokenExpiry");

  setIsAuthenticated(false);
  setUser(null);

  // Refresh page and redirect to "/"
  window.location.href = "/";
};

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    const tokenExpiry = localStorage.getItem("tokenExpiry");

    if (token && tokenExpiry) {
      const currentTime = new Date().getTime();

      // Check token expiry
      if (currentTime > Number(tokenExpiry)) {
        logout();
      } else {
        setIsAuthenticated(true);

        if (userData) {
          setUser(JSON.parse(userData));
        }

        // Auto logout after remaining time
        const remainingTime = Number(tokenExpiry) - currentTime;

        setTimeout(() => {
          logout();
        }, remainingTime);
      }
    }

    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/auth/authenticate`,
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const data = response.data;
      const token = data.token || data.data?.token;
      const userInfo = data.user || data.data?.user || { email };

      if (token) {
        // Expiry time = 1 hour
        const expiryTime = new Date().getTime() + 60 * 60 * 1000;

        // Store data
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(userInfo));
        localStorage.setItem("tokenExpiry", expiryTime);

        setUser(userInfo);
        setIsAuthenticated(true);

        // Auto logout after 1 hour
        setTimeout(() => {
          logout();
        }, 60 * 60 * 1000);


        navigate("/admin/dashboard");

        return { success: true };
      } else {
        alert("Login failed: Token missing in response");
        return { success: false };
      }
    } catch (error) {
      console.error("Login error:", error);

      const errorMessage =
        error.response?.data?.message || "Invalid email or password";

      alert(errorMessage);

      return { success: false };
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};